module.exports = __webpack_public_path__ + "img/icon-genetics.069d7309.png";